import React from 'react';
import './style.scss';

const ToggleSwitch = props => {
  let {
    option1,
    option2,
    label1,
    label2,
    element1,
    element2,
    className = '',
    style,
    onChange,
    toggled,
    disabled
  } = props;

  function onClick(option) {
    if (disabled) return;

    if (toggled) {
      onChange(option);
    } else {
      onChange(option);
    }
  }

  function clickOption1() {
    onClick(option1);
  }

  function clickOption2() {
    onClick(option2);
  }

  let option1Classname = 'option1';
  let option2Classname = 'option2';
  let buttonClassname = 'button';

  if (toggled) {
    option2Classname += ' selected';
    buttonClassname += ' toggled';
  } else option1Classname += ' selected';

  return (
    <div className={'toggle-switch ' + className} style={style}>
      <div className={option1Classname} onClick={clickOption1}>
        {element1 || label1 || option1}
      </div>
      <div className={option2Classname} onClick={clickOption2}>
        {element2 || label2 || option2}
      </div>
      <div className={buttonClassname} />
    </div>
  );
};

export default ToggleSwitch;
